module.exports = __webpack_public_path__ + "static/media/image_placeholder.ebe9884b.jpg";